import type { RotasDoModulo } from '@/app/rotas';

import { TelaInicial } from './TelaInicial';
import { UsersPage } from './UsersPage';

/** Usuarios e perfis. */
export const rotas: RotasDoModulo = {
  menu: {
    '/usuarios': UsersPage,
    // A mesma tela de usuarios, no recorte de quem administra a corretora.
    '/corretora/usuarios': UsersPage,
  },
  moldura: [
    // A aba Perfis de acesso com endereco proprio, como o /usuarios/perfis do OnPoint.
    { path: '/usuarios/perfis', element: <UsersPage /> },
    // A tela inicial do perfil (P-USU-1): o acesso entra por aqui e segue para a tela
    // que o perfil da pessoa escolheu.
    { path: '/inicio', element: <TelaInicial /> },
  ],
};
